import { createContext } from 'react';
import {
  Enterprise,
  EnterpriseBusinessUnit,
  EnterpriseLocation,
  EnterpriseSeniority,
} from 'models/Enterprises';
import { Option } from 'models/Global';
import utils from 'utils';

type EnterpriseContextProps = {
  enterprise: Enterprise;
  units: Option[];
  brokers: Option[];
  updateEnterprise: (enterprise: Partial<Enterprise>) => void;
  updateBusinessUnits: (
    updatedBusinessUnits: EnterpriseBusinessUnit[],
    shouldRefetch?: boolean,
  ) => void;
  updateMemberSeniorities: (
    updatedMemberSeniorities: EnterpriseSeniority[],
    shouldRefetch?: boolean,
  ) => void;
  updateMemberLocations: (
    updatedMemberLocations: EnterpriseLocation[],
    shouldRefetch?: boolean,
  ) => void;
};

export default createContext<Partial<EnterpriseContextProps>>({
  enterprise: null,
  units: [],
  brokers: [],
  updateEnterprise: utils.noop,
  updateBusinessUnits: utils.noop,
  updateMemberSeniorities: utils.noop,
  updateMemberLocations: utils.noop,
});
